import React, { Component } from 'react';
import fetcher from '../../../modules/ajio-fetch';
import { fetchGetJSONResHandler } from '../../../modules/ajio-fetch/utils';
import { STORE_PICKUP_PATH, STORE_RETURN_PATH, COMMON_PAGE_DATA } from './config';

class StoreListModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pincode: props.pincode || '',
      invalidPincodeErrorMsg: '',
      storeAddress: '',
      storeAddressList: {}
    };
  }

  validatePincode = () => {
    const { pincode } = this.state;
    return (
      pincode.length > 6 ||
      pincode.length < 6 ||
      (!pincode.match(/^\d+/) && parseFloat(pincode) != parseInt(pincode)) ||
      isNaN(pincode)
    );
  };

  storeListFromPincode = pincode => {
    fetcher(`api/storepickup/storeDetailsPincodeSearch/${pincode}`)
      .then(fetchGetJSONResHandler)
      .then(response => {
        this.setState({
          storeAddressList: response || {}
        });
      })
      .catch(err => {
        console.log('storeListFromPincode err', err);
      });
  };

  checkPincode = e => {
    e.preventDefault();
    if (this.validatePincode()) {
      const { content: { pinCode: { errorMessagText } = {} } = {} } = COMMON_PAGE_DATA;
      this.setState({
        invalidPincodeErrorMsg: errorMessagText
      });
    } else {
      const { pincode } = this.state;
      this.storeListFromPincode(pincode);
    }
  };

  updatePincode = e => {
    let {
      target: { value: pincode = '' }
    } = e;
    if (pincode.length > 6) {
      pincode = pincode.slice(0, 6);
    }
    pincode = pincode.replace(/[e\+\-\.]/gi, '');
    this.setState({
      pincode,
      invalidPincodeErrorMsg: undefined
    });
  };

  showCashRefundMessage = (refundByCash, refundStaticContent) => {
    const { available = {}, unAvailable = {} } = refundStaticContent;
    const { classes = '', message = '' } = refundByCash ? available : unAvailable;
    return <span className={classes}>{` | ${message}`}</span>;
  };

  getStoreNameEntry = (refundByCash, refundStaticContent) => {
    const { receivedStoreUrlPath = '' } = this.props;
    switch (receivedStoreUrlPath) {
      case STORE_PICKUP_PATH:
        return <span className="cashOnPickup"> | Cash on pickup available</span>;
      case STORE_RETURN_PATH:
        return this.showCashRefundMessage(refundByCash, refundStaticContent);
      default:
        return null;
    }
  };

  render() {
    const {
      content: {
        pinCode: {
          labelText = '',
          headerText = '',
          subHeaderText = '',
          buttonText = '',
          refund: refundStaticContent = {},
          error: { headerText: errorHeaderText = '', subHeaderText: errorSubHeaderText = '' } = {},
          landmarkText = ''
        } = {}
      } = {}
    } = COMMON_PAGE_DATA;

    const {
      pincode,
      invalidPincodeErrorMsg,
      storeAddressList: { status: { statusCode = 2 } = {}, storeNodes = [] } = ({
        storeNodes: []
      } = {})
    } = this.state;

    let storeNodeList = [];
    const { receivedStoreUrlPath = '' } = this.props;
    switch (receivedStoreUrlPath) {
      case STORE_PICKUP_PATH:
        storeNodeList = storeNodes;
        break;
      case STORE_RETURN_PATH:
        storeNodeList = storeNodes.filter(store => store.dropAtStore);
        break;
      default:
        storeNodeList = [];
    }

    return (
      <div className="store-list-view">
        <div className="subHeader">
          <span className="ic-address" />
          <div className="content-header">
            {headerText}
            <div>{subHeaderText}</div>
          </div>
        </div>
        <div className="enter-pincode">
          <label>{labelText}</label>
          <input
            type="number"
            value={pincode}
            onChange={this.updatePincode}
            name="pincode"
            maxLength={6}
            minLength={6}
          />
          <div className="check-button" onClick={this.checkPincode}>
            {buttonText}
          </div>
          <div className="address-error-msg" aria-live='polite'>{invalidPincodeErrorMsg}</div>
        </div>
        {statusCode === 1 && (
          <div className="nostore-message">
            <div>{errorHeaderText}</div>
            <div className="submessage">{errorSubHeaderText}</div>
          </div>
        )}
        {statusCode === 0 &&
          storeNodeList.map(
            ({
              storeNodeID,
              refundByCash,
              storeAddress: { formattedAddress, landmark } = {},
              storeName
            }) => {
              return (
                <div className="addressBox" key={storeNodeID}>
                  <div className="storeName">
                    {storeName}
                    {this.getStoreNameEntry(refundByCash, refundStaticContent)}
                  </div>
                  <div className="formattedAddress">{formattedAddress}</div>
                  <div>
                    <span className="landmark">{landmarkText}</span> {`: ${landmark}`}{' '}
                  </div>
                </div>
              );
            }
          )}
      </div>
    );
  }
}

export default StoreListModal;
